import type { FieldDefinition } from '../data/model';
import { attributeRuleFieldKind } from './fields';
import type { AttributeRuleOperator } from './model';

export interface AttributeRuleOperatorDefinition {
  readonly operator: AttributeRuleOperator;
  readonly label: string;
  readonly valueKind: 'none' | 'number' | 'string';
}

const EMPTY_OPERATORS: readonly AttributeRuleOperatorDefinition[] = [
  { operator: 'is-empty', label: 'is empty', valueKind: 'none' },
  { operator: 'is-not-empty', label: 'is not empty', valueKind: 'none' },
];

const NUMBER_OPERATORS: readonly AttributeRuleOperatorDefinition[] = [
  { operator: 'equals', label: 'equals', valueKind: 'number' },
  { operator: 'does-not-equal', label: 'does not equal', valueKind: 'number' },
  { operator: 'greater-than', label: 'is greater than', valueKind: 'number' },
  {
    operator: 'greater-than-or-equal',
    label: 'is greater than or equal',
    valueKind: 'number',
  },
  { operator: 'less-than', label: 'is less than', valueKind: 'number' },
  {
    operator: 'less-than-or-equal',
    label: 'is less than or equal',
    valueKind: 'number',
  },
  ...EMPTY_OPERATORS,
];

const STRING_OPERATORS: readonly AttributeRuleOperatorDefinition[] = [
  { operator: 'equals', label: 'equals', valueKind: 'string' },
  { operator: 'does-not-equal', label: 'does not equal', valueKind: 'string' },
  { operator: 'contains', label: 'contains', valueKind: 'string' },
  { operator: 'does-not-contain', label: 'does not contain', valueKind: 'string' },
  ...EMPTY_OPERATORS,
];

const BOOLEAN_OPERATORS: readonly AttributeRuleOperatorDefinition[] = [
  { operator: 'is-true', label: 'is true', valueKind: 'none' },
  { operator: 'is-false', label: 'is false', valueKind: 'none' },
  ...EMPTY_OPERATORS,
];

export function attributeRuleOperatorsForField(
  field: FieldDefinition,
): readonly AttributeRuleOperatorDefinition[] {
  switch (attributeRuleFieldKind(field)) {
    case 'number':
      return NUMBER_OPERATORS;
    case 'string':
      return STRING_OPERATORS;
    case 'boolean':
      return BOOLEAN_OPERATORS;
    case null:
      return [];
  }
}

export function attributeRuleOperatorDefinition(
  field: FieldDefinition,
  operator: AttributeRuleOperator,
): AttributeRuleOperatorDefinition | null {
  return (
    attributeRuleOperatorsForField(field).find((definition) => definition.operator === operator) ??
    null
  );
}
